<script>
import Icon from './Icon.vue';

export default {
  components: { Icon },

  props: {
    link: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: '',
    },
  },

  methods: {
    redirect() {
      window.location.href = this.link;
    },
  },
};
</script>

<template>
  <i v-if="icon.length > 0 && name.length === 0" class="nav-icon" :class="icon" @click="redirect" />
  <a v-else :href="link" class="darkmode-ignore">
    {{ name }}
  </a>
</template>
